module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-qb-down"><div class="qb-down prize"><p> ' +
((__t = (title)) == null ? '' : __t) +
' </p><p> ' +
((__t = (msg)) == null ? '' : __t) +
' </p><div class="btn"><a class="downQb" id="downloadQBBtn" href="https://dldir1.qq.com/invc/tt/QQBrowser_Setup_QB10.exe" onclick="_qblog.wsd.click(\'RELEASEMEBABY.QBDOWN.CLICK\');">下载QQ浏览器</a></div></div></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./modules/mask/qb.down.html
// module id = 28
// module chunks = 0